//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
  const uia = angular.module('uia');

  uia.config(['$stateProvider', 'UniversalImageActionsView', 'UniversalImageActionWorkflows',
    function($stateProvider, UniversalImageActionsView, UniversalImageActionWorkflows) {
      $stateProvider
                .state('Home', {
                  views: {
                    panel: { template: require('@legacy-components/common/universal-image-actions/universal-image-actions-home.html') },
                  },
                })
                .state('distribute', {
                  views: {
                    panel: { template: '<universal-image-actions-workflow></universal-image-actions-workflow>' },
                  },
                  abstract: true,
                });

            // Loop through possible views and attach states when appropriate
      _.chain(UniversalImageActionsView)
                .reject((value) => { return value.name === 'Home'; }) // Filter out "Home" to attach workflow states
                .each((value) => {
                  $stateProvider.state(`distribute.${value.name}`, {
                    views: {
                      'panel': { template: value.template },
                            // Target the 'overlay' named view within the root state (universal-image-actions-modal.html)
                      'overlay@': { template: value.overlay || '' },
                    },
                  });
                })
                // Filter out workflows before attaching standalone states
                .reject((value) => { return !!UniversalImageActionWorkflows[value.name]; })
                .each((value) => {
                  $stateProvider.state(value.name, {
                    views: {
                      panel: { template: value.template },
                      overlay: { template: value.overlay || '' },
                    },
                  });
                });
    },
  ]);
})();
